class LoadMore {
    constructor(buttonClass, gridClass, loadMoreInterval) {
        this.loadMoreButton = document.querySelector(`.${buttonClass}`);
        this.grid = document.querySelector(`.${gridClass}`);
        this.loadMoreInterval = loadMoreInterval;
        this.matchCounter = 0;
        this.initialize();
    }

    initialize() {
        this.showButton();
        this.loadMoreButton.addEventListener('click', () => this.loadMoreCards());
        this.filterInitialCards();
    }

    showButton() {
        if (this.loadMoreButton) {
            this.loadMoreButton.classList.remove('button--hidden');
        }
    }

    hideButton() {
        if (this.loadMoreButton) {
            this.loadMoreButton.classList.add('button--hidden');
        }
    }

    filterInitialCards() {
        const cards = this.grid.querySelectorAll('.content-grid-2-0__card');
        cards.forEach(card => {
            if (this.matchCounter >= this.loadMoreInterval) {
                card.classList.add('card--load-more');
            }
            this.matchCounter++;
        });
        this.updateLoadMoreButton();
    }

    loadMoreCards() {
        const hiddenCards = this.grid.querySelectorAll('.content-grid-2-0__card.card--load-more');
        hiddenCards.forEach((card, index) => {
            if (index < this.loadMoreInterval) {
                card.classList.remove('card--load-more');
            }
        });
        this.updateLoadMoreButton();
    }

    updateLoadMoreButton() {
        const remainingCards = this.grid.querySelectorAll('.content-grid-2-0__card.card--load-more');
        if (remainingCards.length === 0) {
            this.hideButton();
        } else {
            this.showButton();
        }
    }
}

// Wacht tot de DOM volledig geladen is
document.addEventListener('DOMContentLoaded', function() {
    const loadMoreInterval = parseInt(document.querySelector('.content-grid-2-0__card-wrapper').dataset.loadMore, 10);
    new LoadMore('content-grid-2-0__card-load-more-button', 'content-grid-2-0__card-wrapper', loadMoreInterval);
});
